/**
 * Il vocabolario degli stati di allarme.
 *
 * **Lo detta il database, non noi.** Il server legge e scrive la STESSA
 * tabella dell'app standalone — un database che arriva da un PC di impianto
 * si copia e basta — e li' dentro gli stati si chiamano come li scrive il
 * C++: `ACKED` e `SHLVD`, non `ACK` e `SHELVED`.
 *
 * Il porting li aveva ribattezzati, e la conseguenza non era estetica: con
 * `state IN ('UNACK','ACK','RTNUN')` un allarme confermato sull'app desktop
 * non risultava ne' attivo ne' chiuso, e uno silenziato non compariva fra i
 * silenziati. Su una tabella copiata da un impianto vero sarebbero spariti
 * tutti dalla vista, senza nessun errore.
 *
 * Le due grafie vecchie restano accettate in LETTURA — questo server ne ha
 * gia' scritte — ma non se ne producono piu'.
 */
export const ALARM_STATE = {
    /** Scattato, nessuno l'ha ancora confermato. */
    unack: "UNACK",
    /** Confermato da una persona. */
    acked: "ACKED",
    /** Il gas e' rientrato ma nessuno ha confermato: e' quello che si dimentica. */
    rtnun: "RTNUN",
    /** Rientrato e chiuso. */
    norm: "NORM",
    /** Silenziato a tempo. */
    shelved: "SHLVD",
    /** Soppresso da progetto / fuori servizio: li scrive l'AlarmEngine. */
    designSuppressed: "DSUPR",
    outOfService: "OOSRV",
};
/** Le grafie che questo server ha scritto prima dell'allineamento. Servono
 *  solo a non perdere di vista quelle righe. */
export const LEGACY_ACKED = "ACK";
export const LEGACY_SHELVED = "SHELVED";
/** Stati in cui un allarme e' ancora "vivo" per l'operatore. */
export const ACTIVE_ALARM_STATES = [
    ALARM_STATE.unack,
    ALARM_STATE.acked,
    ALARM_STATE.rtnun,
    LEGACY_ACKED,
];
/** Stati che aspettano ancora una mano. */
export const UNACKED_ALARM_STATES = [ALARM_STATE.unack, ALARM_STATE.rtnun];
/** Tutte le grafie che significano "silenziato". */
export const SHELVED_ALARM_STATES = [ALARM_STATE.shelved, LEGACY_SHELVED];
/** Riporta alla grafia del database una qualsiasi delle due. Da usare prima
 *  di confrontare uno stato letto altrove. */
export function normalizeAlarmState(state) {
    if (state === LEGACY_ACKED)
        return ALARM_STATE.acked;
    if (state === LEGACY_SHELVED)
        return ALARM_STATE.shelved;
    return state;
}
export function isShelved(state) {
    return normalizeAlarmState(state) === ALARM_STATE.shelved;
}
export function isAcknowledged(state) {
    return normalizeAlarmState(state) === ALARM_STATE.acked;
}
/** L'allarme aspetta ancora una conferma. */
export function needsAck(state) {
    return UNACKED_ALARM_STATES.includes(normalizeAlarmState(state));
}
//# sourceMappingURL=alarm-states.js.map